// Each import.meta.env.VITE_* MUST be referenced by its full literal name —
// Vite statically replaces only the verbatim expression at build time. Reading
// through a variable alias or a dynamic key would NOT be inlined and would be
// undefined in the production browser bundle.
//
// pickEnv: build-time inlined value wins over the runtime/test (process.env)
// override, but an empty string is treated as "unset" so a blank root .env
// placeholder (e.g. `VITE_NETWORK=`) falls through to the shell value and the
// documented defaults instead of silently masking them — plain ?? would keep
// the empty string.
export const pickEnv = (inlined?: string, runtime?: string): string | undefined =>
  (inlined !== undefined && inlined !== '' ? inlined : undefined) ??
  (runtime !== undefined && runtime !== '' ? runtime : undefined);

const inlinedExists = typeof import.meta.env !== 'undefined';
const runtimeExists = typeof process !== 'undefined';

export const envVariables = {
  VITE_ENV: pickEnv(
    inlinedExists ? import.meta.env.VITE_ENV : undefined,
    runtimeExists ? process.env.VITE_ENV : undefined,
  ),
  VITE_NETWORK: pickEnv(
    inlinedExists ? import.meta.env.VITE_NETWORK : undefined,
    runtimeExists ? process.env.VITE_NETWORK : undefined,
  ),
  VITE_BITTENSOR_TESTNET_RPC_URL: pickEnv(
    inlinedExists ? import.meta.env.VITE_BITTENSOR_TESTNET_RPC_URL : undefined,
    runtimeExists ? process.env.VITE_BITTENSOR_TESTNET_RPC_URL : undefined,
  ),
  VITE_BITTENSOR_TESTNET_SUBTENSOR_WS_URL: pickEnv(
    inlinedExists ? import.meta.env.VITE_BITTENSOR_TESTNET_SUBTENSOR_WS_URL : undefined,
    runtimeExists ? process.env.VITE_BITTENSOR_TESTNET_SUBTENSOR_WS_URL : undefined,
  ),

  // Third-parties
  VITE_SENTRY_DSN: pickEnv(
    inlinedExists ? import.meta.env.VITE_SENTRY_DSN : undefined,
    runtimeExists ? process.env.VITE_SENTRY_DSN : undefined,
  ),
  VITE_POSTHOG_API_KEY: pickEnv(
    inlinedExists ? import.meta.env.VITE_POSTHOG_API_KEY : undefined,
    runtimeExists ? process.env.VITE_POSTHOG_API_KEY : undefined,
  ),
  VITE_POSTHOG_HOST_URL: pickEnv(
    inlinedExists ? import.meta.env.VITE_POSTHOG_HOST_URL : undefined,
    runtimeExists ? process.env.VITE_POSTHOG_HOST_URL : undefined,
  ),
  VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID: pickEnv(
    inlinedExists ? import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID : undefined,
    runtimeExists ? process.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID : undefined,
  ),
  VITE_ZYFI_API_KEY: pickEnv(
    inlinedExists ? import.meta.env.VITE_ZYFI_API_KEY : undefined,
    runtimeExists ? process.env.VITE_ZYFI_API_KEY : undefined,
  ),
  VITE_ALCHEMY_API_KEY: pickEnv(
    inlinedExists ? import.meta.env.VITE_ALCHEMY_API_KEY : undefined,
    runtimeExists ? process.env.VITE_ALCHEMY_API_KEY : undefined,
  ),
  VITE_NODE_REAL_API_KEY: pickEnv(
    inlinedExists ? import.meta.env.VITE_NODE_REAL_API_KEY : undefined,
    runtimeExists ? process.env.VITE_NODE_REAL_API_KEY : undefined,
  ),
  VITE_THE_GRAPH_API_KEY: pickEnv(
    inlinedExists ? import.meta.env.VITE_THE_GRAPH_API_KEY : undefined,
    runtimeExists ? process.env.VITE_THE_GRAPH_API_KEY : undefined,
  ),
  VITE_BICONOMY_API_KEY: pickEnv(
    inlinedExists ? import.meta.env.VITE_BICONOMY_API_KEY : undefined,
    runtimeExists ? process.env.VITE_BICONOMY_API_KEY : undefined,
  ),
  VITE_SAFE_API_KEY: pickEnv(
    inlinedExists ? import.meta.env.VITE_SAFE_API_KEY : undefined,
    runtimeExists ? process.env.VITE_SAFE_API_KEY : undefined,
  ),
};
